module.exports = __webpack_public_path__ + "img/inadequate.c0035742.svg";